import React from "react";
import Button from "../elements/Button";
import { Fade } from "react-reveal";
import { MdOutlineClose } from "react-icons/md";
import { FaGithub } from "react-icons/fa";
import { RxVercelLogo } from "react-icons/rx";

export default function ProjectDetail(props) {
  //prevent scroll when modal is open
  if (props.isOpen) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }

  //get hidden className
  const className = props.className;

  if (!props.projectId) {
    return null;
  }

  //filter project data for modal
  let projectDetail = props.project.filter(
    (data) => data.id === props.projectId
  );

  return (
    <div
      className={[
        "fixed z-50 bg-white sm:bg-black sm:bg-opacity-50 w-full h-full overflow-y-scroll mb-5",
        className,
      ].join(" ")}
    >
      <Fade bottom>
        {/* <div className="w-9/12 max-w-lg m-auto mt-20"> */}
        <div className="w-full h-screen sm:w-9/12 sm:max-w-lg sm:m-auto sm:mt-20">
          <div className="bg-white w-full h-10 text-right">
            <Button
              isDense
              className="font-bold text-3xl opacity-75 hover:opacity-100"
              style={{ padding: "0.44rem" }}
              onClick={props.closeProjectModal}
            >
              <MdOutlineClose size={26} />
            </Button>
          </div>
          <div
            className={`${
              projectDetail[0].background || "bg-white"
            } select-none w-full`}
            style={{ maxHeight: "20rem" }}
          >
            {projectDetail[0].imageUrl ? (
              <img
                src={`/images/project-display/${projectDetail[0].imageUrl}`}
                alt="firebnb img"
                className="w-full object-cover object-top"
                style={{ maxHeight: "20rem" }}
              />
            ) : (
              <p className="px-5 text-center">Load image...</p>
            )}
          </div>
          <div className="relative font-light bg-white pt-3 px-8 text-center sm:text-left">
            <div className="p-5 pb-8 sm:pb-12">
              <h2 className="font-semibold text-lg mb-3">
                {projectDetail[0].title}
              </h2>
              <p id="text-base" className="text-justify">
                {projectDetail[0].article}
              </p>
              <div id="external-url-container" className="flex mt-6">
                <div
                  id="url-wrapper"
                  className="flex gap-4 flex-wrap mr-auto font-normal text-white mx-auto sm:ml-0"
                >
                  {projectDetail[0].github_link && (
                    <Button
                      className="flex gap-3 text-center bg-black hover:bg-gray-800 active:bg-gray-900 mx-auto"
                      type="link"
                      isDense
                      isExternal
                      href={projectDetail[0].github_link}
                      target="_blank"
                    >
                      <span>Github</span>
                      <FaGithub className="my-auto" />
                    </Button>
                  )}
                  {projectDetail[0].vercel_link && (
                    <Button
                      className="flex gap-3 text-center bg-black hover:bg-gray-800 active:bg-gray-900 mx-auto"
                      type="link"
                      isDense
                      isExternal
                      href={projectDetail[0].vercel_link}
                      target="_blank"
                    >
                      <span>Demo</span>
                      <RxVercelLogo className="my-auto" />
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fade>
    </div>
  );
}
